<div
  class="modal h-100 w-100 d-flex justify-content-center align-items-center background-opacity-dark animate__animated animate__fadeIn"
>
  <div class="modal-background height-modal width-modal">
    <app-info360-container
      *ngIf="item"
      [item]="item"
      [client]="client"
      (close)="closeMe()"
    ></app-info360-container>
    <app-help
      *ngIf="helpOpened"
      [movementType]="movementType"
      (close)="closeMe()"
    ></app-help>
  </div>
</div>
